module.exports = __webpack_public_path__ + "static/media/verificationico.b12dda77.svg";